import { useEffect } from "react";
import { openModal, closeModal } from "@lululemon/auth-ui";

export const useV3SigninModal = ({
  username,
  mode,
  source,
  onLoginSuccess,
  onLoginError,
  isOpen,
  createAccountOpen,
  onClose,
  skipOrderMerge,
  skipModalClose,
  showContinueAsGuest,
  continueAsGuestCallback,
  additionalAnalytics
}) => {
  useEffect(() => {
    if (isOpen) {
      openModal({
        username,
        mode,
        source,
        onLoginSuccess,
        onLoginError,
        createAccountOpen,
        onClose,
        skipOrderMerge,
        skipModalClose,
        showContinueAsGuest,
        continueAsGuestCallback,
        additionalAnalytics
      });
    }
  }, [isOpen]);

  return { closeModal };
};
